import TagsInput from '@gef-ui/components/atoms/TagsInput/TagsInput';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import isArray from "ramda-extension/es/isArray";
import React from 'react';
import { inputColor, validationColor } from '../../../../constants';
export default (({ errMeta, codelistName, optionsFilter, options, removeFileInput, handleChange, viewParser, focus, handleUpdate, handleAsyncValidate, value, handleValidate, valid, disabled, errMessage, onChange, handleFocusTrue, handleFocusFalse, label, fieldName, onBlur, onFocus, formName, ...other })=>/*#__PURE__*/ React.createElement(TagsInput, {
        id: fieldName,
        validationText: errMessage,
        floatingLabelText: label,
        controlClassName: inputColor(valid),
        disabled: disabled,
        validationClassName: validationColor(valid),
        value: isArray(value) ? value : [],
        onChange: chainHandlers([
            handleUpdate,
            onChange
        ]),
        onFocus: chainHandlers([
            handleFocusTrue,
            onFocus
        ]),
        onBlur: chainHandlers([
            handleFocusFalse,
            handleAsyncValidate,
            handleValidate,
            onBlur
        ]),
        ...other
    }));
